// extracted by mini-css-extract-plugin
export default {"app":"FixPhoto_app__ioTNV","headerBar":"FixPhoto_headerBar__8eYGj","view":"FixPhoto_view__gc3Vg","mask":"FixPhoto_mask__TlJuq","photo":"FixPhoto_photo__w8zTN"};